<template>
  <div class="px-0 pb-0 card-body">
    <div v-if="loading && filteredData.length === 0" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading CDATA EPON data...</p>
    </div>
    <div class="table-responsive" v-else-if="filteredData.length > 0">
      <div class="card mb-4">
        <div class="card-body px-0 pt-0 pb-2 invoice">
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Port
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    MAC Address
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    LLID
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    ONU ID
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    PPPOE ID
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Last Seen
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Last Event
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(onu, index) in filteredData" :key="index">
                  <td class="align-middle text-center text-sm">
                    {{ onu.port }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatMacAddress(onu.mac) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ onu.llid }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ onu.reg_port_or_onu_id }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span v-if="onu.PPPOE_ID === 'Loading...'">
                      <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                    </span>
                    <span v-else>
                      {{ onu.PPPOE_ID ?? 'N/A' }}
                    </span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatLastSeen(onu.last_interval_sec) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatLastEvent(onu.last_event) }}
                  </td>
                  <td class="text-center">
                    <soft-badge
                      class="p-1 rounded-1 text-white cursor-pointer text-sm"
                      :class="getStatusBadgeClass(onu.link_status)"
                      variant="gradient"
                      size="sm"
                    >
                      {{ formatStatus(onu.link_status) }}
                    </soft-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <Skalaton />
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";

export default {
  name: "CdataV12EponTable",
  components: {
    Skalaton
  },
  props: {
    loading: Boolean,
    loadingPPPOE: Boolean,
    filteredData: {
      type: Array,
      default: () => []
    },
    sortKey: String,
    sortOrder: String
  },
  methods: {
    getStatusBadgeClass(status) {
      const statusLower = (status || '').toLowerCase();
      if (statusLower === 'down') return 'bg-danger';
      if (statusLower === 'up') return 'bg-success';
      return 'bg-warning';
    },
    
    formatStatus(status) {
      return (status || '').toUpperCase();
    },
    
    formatLastSeen(seconds) {
      if (!seconds && seconds !== 0) return 'N/A';
      
      const sec = parseInt(seconds);
      if (sec < 60) return `${sec} seconds ago`;
      if (sec < 3600) return `${Math.floor(sec / 60)} minutes ago`;
      if (sec < 86400) return `${Math.floor(sec / 3600)} hours ago`;
      return `${Math.floor(sec / 86400)} days ago`;
    },
    
    formatLastEvent(event) {
      if (!event) return 'N/A';
      return event.toUpperCase();
    },
    
    formatMacAddress(mac) {
      if (!mac) return 'N/A';
      
      // Remove any existing separators and convert to lowercase
      const cleanMac = mac.replace(/[^a-f0-9]/gi, '').toLowerCase();
      
      // Format as xx:xx:xx:xx:xx:xx
      return cleanMac.match(/.{1,2}/g)?.join(':') || mac;
    }
  }
};
</script>

<style scoped>
/* Your existing styles remain unchanged */
.table th {
  padding: 12px 24px !important;
}

.sort-icon {
  margin-left: 5px;
}

.asc::after {
  content: "▲";
}

.desc::after {
  content: "▼";
}

.bg-danger {
  background-color: #f56565 !important;
}

.bg-success {
  background-color: #48bb78 !important;
}

.bg-warning {
  background-color: #ed8936 !important;
}
</style>